"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_SERVER_DOWN = exports.SET_HOSTS = void 0;
exports.SET_HOSTS = 'SET_HOSTS';
exports.SET_SERVER_DOWN = 'SET_SERVER_DOWN';
